import polyglotI18nProvider from 'ra-i18n-polyglot'
import ptBrMessages from 'ra-language-pt-br'
import { Admin, Resource } from 'react-admin'
import authProvider from './authProvider'
import closeSidebarSaga from './closeSidebarSaga'
import customRoutes from './customRoutes'
import myDataProvider from './dataProvider'
import MyLoginPage from './pages/myLoginPage'
import {
    UserCreate,
    UserEdit,
    UserIcon,
    UserList,
    UserShow,
} from './resources/users/users'

//assistance
import {
    AssistanceCouponCreate,
    AssistanceCouponEdit,
    AssistanceCouponIcon,
    AssistanceCouponList,
} from './resources/assistance/assistanceCoupons/assistanceCoupons'
import {
    AssistanceOrderEdit,
    AssistanceOrderList,
    AssistanceOrderListQueue,
    AssistanceOrderListRemoved,
    AssistanceOrderShow,
    QueueIcon,
    RemovedIcon,
} from './resources/assistance/assistanceOrders/assistanceOrders'
import {
    AssistanceTagCreate,
    AssistanceTagEdit,
    AssistanceTagIcon,
    AssistanceTagList,
} from './resources/assistance/assistanceTags/assistanceTags'
import { BenchmarkList } from './resources/assistance/benchmark/benchmark'
import {
    CoverageGroupCreate,
    CoverageGroupEdit,
    CoverageGroupIcon,
    CoverageGroupList,
} from './resources/assistance/coverageGroups/coverageGroups'
import {
    CoveragesCreate,
    CoveragesEdit,
    CoveragesIcon,
    CoveragesList,
} from './resources/assistance/coverages/coverages'
import {
    DestinationsCreate,
    DestinationsEdit,
    DestinationsIcon,
    DestinationsList,
} from './resources/assistance/destinations/destinations'
import {
    EnterpriseCreate,
    EnterpriseEdit,
    EnterpriseIcon,
    EnterpriseList,
    EnterpriseShow,
} from './resources/assistance/enterprises/enterprises'
import {
    EnterpriseProductCreate,
    EnterpriseProductEdit,
    EnterpriseProductIcon,
    EnterpriseProductShow,
} from './resources/assistance/enterpriseProducts/enterpriseProducts'
import {
    EnterpriseProductFareAgeCreate,
    EnterpriseProductFareAgeEdit,
} from './resources/assistance/enterpriseProductFareAges/enterpriseProductFareAges'
import {
    ExchangeRatesCreate,
    ExchangeRatesEdit,
    ExchangeRatesIcon,
    ExchangeRatesList,
} from './resources/assistance/exchangeRates/exchangeRates'
import {
    InsurersCreate,
    InsurersEdit,
    InsurersIcon,
    InsurersList,
} from './resources/assistance/insurers/insurers'
import {
    LabelsCreate,
    LabelsEdit,
    LabelsIcon,
    LabelsList,
} from './resources/assistance/labels/labels'
import {
    PaymentTypesCreate,
    PaymentTypesEdit,
} from './resources/assistance/paymentTypes/paymentTypes'
import {
    ProductCoveragesCreate,
    ProductCoveragesEdit,
} from './resources/assistance/productCoverages/productCoverages'
import {
    ProductDestinationsCreate,
} from './resources/assistance/productDestinations/productDestinations'
import {
    ProductFareAgeCreate,
    ProductFareAgeEdit,
    ProductFareAgeIcon,
} from './resources/assistance/productFareAges/productFareAges'
import {
    ProductsCreate,
    ProductsEdit,
    ProductsIcon,
    ProductsList,
    ProductsShow,
} from './resources/assistance/products/products'
import {
    ProductTagCreate,
    ProductTagEdit,
    ProductTagIcon,
} from './resources/assistance/productTags/productTags'
import {
    SearchEdit,
    SearchIcon,
    SearchList,
} from './resources/assistance/search/search'
import {
    SettingsEdit,
    SettingsIcon,
    SettingsList,
} from './resources/assistance/settings/settings'
import {
    PromotionCreate,
    PromotionEdit,
    PromotionIcon,
    PromotionList,
    PromotionShow,
} from './resources/assistance/promotions/promotions'
import {
    CampaignCreate,
    CampaignEdit,
    CampaignIcon,
    CampaignList,
    CampaignShow,
} from './resources/assistance/campaigns/campaigns'

const messages = {
    'pt-br': ptBrMessages,
}
const i18nProvider = polyglotI18nProvider(
    (locale) => messages[locale],
    'pt-br',
    { allowMissing: true, onMissingKey: (key, _, __) => key }
)

//const i18nProvider = polyglotI18nProvider(() => ENi18n, "en", { allowMissing: true, onMissingKey: (key, _, __) => key });

const App = () => {
    return (
        <Admin
            customSagas={[closeSidebarSaga]}
            authProvider={authProvider}
            i18nProvider={i18nProvider}
            loginPage={MyLoginPage}
            customRoutes={customRoutes}
            dataProvider={myDataProvider}
        >
            {(permissions) => {
                return [
                    permissions.includes('assistanceadmin') ||
                    permissions.includes('apimanager') ||
                    permissions.includes('assistanceuser')
                        ? [
                              <Resource
                                  name="admin/assistanceOrders"
                                  options={{ label: 'Pedidos (Seguros)' }}
                                  list={AssistanceOrderList}
                                  show={AssistanceOrderShow}
                                  edit={AssistanceOrderEdit}
                              />,
                            //   <Resource
                            //       name="admin/assistanceOrdersQueue"
                            //       options={{ label: 'Pedidos (Fila)' }}
                            //       list={AssistanceOrderListQueue}
                            //       show={AssistanceOrderShow}
                            //       edit={AssistanceOrderEdit}
                            //       icon={QueueIcon}
                            //   />,
                            //   <Resource
                            //       name="admin/assistanceOrdersRemoved"
                            //       options={{ label: 'Pedidos (Removidos)' }}
                            //       list={AssistanceOrderListRemoved}
                            //       show={AssistanceOrderShow}
                            //       edit={AssistanceOrderEdit}
                            //       icon={RemovedIcon}
                            //   />,
                          ]
                        : null,
                    permissions.includes('sysadmin')
                        ? [
                              <Resource
                                  name="admin/labels"
                                  options={{ label: 'Labels' }}
                                  list={LabelsList}
                                  create={LabelsCreate}
                                  edit={LabelsEdit}
                                  icon={LabelsIcon}
                              />,
                              <Resource
                                  name="admin/insurers"
                                  options={{ label: 'Seguradoras' }}
                                  list={InsurersList}
                                  create={InsurersCreate}
                                  edit={InsurersEdit}
                                  icon={InsurersIcon}
                              />,
                              <Resource
                                  name="admin/products"
                                  options={{ label: 'Produtos' }}
                                  list={ProductsList}
                                  create={ProductsCreate}
                                  edit={ProductsEdit}
                                  show={ProductsShow}
                                  icon={ProductsIcon}
                              />,
                              <Resource
                                  name="admin/coverages"
                                  options={{ label: 'Coberturas' }}
                                  list={CoveragesList}
                                  create={CoveragesCreate}
                                  edit={CoveragesEdit}
                                  icon={CoveragesIcon}
                              />,
                              <Resource
                                  name="admin/productCoverages"
                                  options={{ label: 'Cobertura' }}
                                  create={ProductCoveragesCreate}
                                  edit={ProductCoveragesEdit}
                              />,
                              <Resource
                                  name="admin/coverageGroups"
                                  options={{ label: 'Grupo de Coberturas' }}
                                  list={CoverageGroupList}
                                  create={CoverageGroupCreate}
                                  edit={CoverageGroupEdit}
                                  icon={CoverageGroupIcon}
                              />,
                              <Resource
                                  name="admin/assistanceTags"
                                  options={{ label: 'Tags' }}
                                  list={AssistanceTagList}
                                  create={AssistanceTagCreate}
                                  edit={AssistanceTagEdit}
                                  icon={AssistanceTagIcon}
                              />,
                              <Resource
                                  name="admin/productTags"
                                  options={{ label: 'ProductTags' }}
                                  create={ProductTagCreate}
                                  edit={ProductTagEdit}
                                  icon={ProductTagIcon}
                              />,
                              <Resource
                                  name="admin/productFareAges"
                                  options={{ label: 'ProductFareAges' }}
                                  create={ProductFareAgeCreate}
                                  edit={ProductFareAgeEdit}
                                  icon={ProductFareAgeIcon}
                              />,
                              <Resource
                                  name="admin/destinations"
                                  options={{ label: 'Destinos' }}
                                  list={DestinationsList}
                                  create={DestinationsCreate}
                                  edit={DestinationsEdit}
                                  icon={DestinationsIcon}
                              />,
                              <Resource
                                  name="admin/productDestinations"
                                  options={{ label: 'Destinos Cadastro' }}
                                  create={ProductDestinationsCreate}
                                  icon={DestinationsIcon}
                              />,
                              <Resource
                                  name="admin/search"
                                  options={{ label: 'Buscador' }}
                                  list={SearchList}
                                  edit={SearchEdit}
                                  icon={SearchIcon}
                              />,
                              <Resource
                                  name="admin/benchmark"
                                  options={{ label: 'Benchmark' }}
                                  list={BenchmarkList}
                                  icon={SearchIcon}
                              />,
                              <Resource
                                  name="admin/paymentTypes"
                                  options={{ label: 'Formas de pagamento' }}
                                  create={PaymentTypesCreate}
                                  edit={PaymentTypesEdit}
                              />,
                              <Resource
                                  name="admin/assistanceCoupons"
                                  options={{ label: 'Cupons' }}
                                  list={AssistanceCouponList}
                                  create={AssistanceCouponCreate}
                                  edit={AssistanceCouponEdit}
                                  icon={AssistanceCouponIcon}
                              />,
                              <Resource
                                  name="admin/exchangeRates"
                                  options={{
                                      label: 'Câmbio',
                                  }}
                                  list={ExchangeRatesList}
                                  create={ExchangeRatesCreate}
                                  edit={ExchangeRatesEdit}
                                  icon={ExchangeRatesIcon}
                              />,
                              <Resource
                                  name="admin/settings"
                                  options={{ label: 'Configurações' }}
                                  list={SettingsList}
                                  edit={SettingsEdit}
                                  icon={SettingsIcon}
                              />,
                              <Resource
                                  name="admin/users"
                                  options={{ label: 'Usuários' }}
                                  list={UserList}
                                  show={UserShow}
                                  create={UserCreate}
                                  edit={UserEdit}
                                  icon={UserIcon}
                              />,
                              <Resource
                                  name="admin/enterprises"
                                  options={{ label: 'Empresas' }}
                                  list={EnterpriseList}
                                  show={EnterpriseShow}
                                  create={EnterpriseCreate}
                                  edit={EnterpriseEdit}
                                  icon={EnterpriseIcon}
                              />,
                              <Resource
                                  name="admin/enterpriseProducts"
                                  options={{ label: 'Produtos da Empresa' }}
                                  show={EnterpriseProductShow}
                                  create={EnterpriseProductCreate}
                                  edit={EnterpriseProductEdit}
                                  icon={EnterpriseProductIcon}
                              />,
                              <Resource
                                  name="admin/enterpriseProductFareAges"
                                  options={{ label: 'Tarifas da Empresa' }}
                                  create={EnterpriseProductFareAgeCreate}
                                  edit={EnterpriseProductFareAgeEdit}
                              />,
                              <Resource
                                  name="admin/promotions"
                                  options={{ label: 'Promoções' }}
                                  list={PromotionList}
                                  show={PromotionShow}
                                  create={PromotionCreate}
                                  edit={PromotionEdit}
                                  icon={PromotionIcon}
                              />,
                              <Resource
                                  name="admin/campaigns"
                                  options={{ label: 'Campanhas' }}
                                  list={CampaignList}
                                  show={CampaignShow}
                                  create={CampaignCreate}
                                  edit={CampaignEdit}
                                  icon={CampaignIcon}
                              />,
                          ]
                        : null,
                    permissions.includes('markupmanager') &&
                    !permissions.includes('sysadmin')
                        ? [
                              <Resource
                                  name="admin/products"
                                  options={{ label: 'Produtos' }}
                                  list={ProductsList}
                                  edit={ProductsEdit}
                                  icon={ProductsIcon}
                              />,
                              <Resource
                                  name="admin/settings"
                                  options={{ label: 'Configurações' }}
                                  list={SettingsList}
                                  edit={SettingsEdit}
                                  icon={SettingsIcon}
                              />,
                          ]
                        : null,
                ]
            }}
        </Admin>
    )
}

export default App
